import { z } from "zod";
import { zPermissionsList } from "./Permission";
import { zArticleNumberInfo } from "./ZArticleNumberInfo";
import { zSystemAttributeType } from "./ZSystemAttributeType";
import { zUid } from "./zUid";
import { zDisplayId } from "./ZDisplayId";

export const zAttributeValue = z.object({
  id: zUid,
  displayId: zDisplayId.nullish(),
  value: z.string().nullable(),
  sortOrder: z
    .number()
    .nullish()
    .describe(
      "Ранг значения атрибута, используется для сортировки значений справочника",
    ),
});
export type ZAttributeValue = z.infer<typeof zAttributeValue>;

export const zAttribute = z.object({
  id: zUid,
  displayId: zDisplayId.nullish(),
  name: z.string(),
  valueType: z.number(),
  fieldKey: z.string().nullish(),
  referenceId: zUid.nullish(), // id справочника, если valueType - Справочник
  values: zAttributeValue.array().nullish(),
  valueId: zUid.nullish(), // Ссылка на значение справочника, если атрибут входит в Dictionary-группу
  roleIds: zUid.array().nullish(), // LPLM-665
  // Свойства компонента на карточке сущности. Название неудачное, но и этого пришлось неделю ждать.
  viewStyles: z.string().nullish(),
  viewType: z.string().nullish(),
  permissions: zPermissionsList.nullish(),
  iterator: z.boolean().optional(), // Если true, то будет создаваться несколько экземпляров для каждого из выбранных значений данного атрибута.
  clearByCopy: z.boolean().optional(), // Очищать/не очищать значение атрибута при копировании
  pathValue: zUid.array().nullish(), // нужен только для атрибута с типом AttrTypeName.linkedValue, для остальных = null, означает путь до присоединяемого атрибута
  parentAttributeId: zUid.nullish(), // ID атрибута связанного объекта, с которым происходит сравнение
  linkAttributeId: zUid.nullish(), // ID атрибута "Ссылка на другой объект" внутри объекта, со значением атрибута которого мы проводим сравнение
  withRestrictions: z.boolean().nullish(), // Копировать/не копировать ограничения по значению (актуально только при сравнении справочников)
  articleNumberInfo: zArticleNumberInfo.nullish(), // Актуально только для атрибута с типом AttrTypeName.article, хранит инормацию об артикле
  systemAttributeType: zSystemAttributeType.nullish(), // Актуально только для виртуальных атрибутов
  filter: zUid.nullish(), // Актуально только для атрибута с типом AttrTypeName.object, хранит инормацию об ограничениях списка экземпляров
  backlinkAttributeId: zUid.nullish(), // LPLM-5479: атрибут на целевом объекте для ограничения списка входящими ссылками
  childDictionaryAttributeId: zUid.nullish(), // LPLM-5545: справочник зависимого объекта, ограничивающий список
  childDictionaryValueId: zUid.nullish(), // LPLM-5545: значение ограничивающего справочника
  autofillByCopy: z.boolean().nullish(), // LPLM-5060
  uniqueValue: z.boolean().nullish(), // LPLM-5701: уникальное значение атрибута среди всех экземпляров объекта Только для атрибутов: текст, артикул, целое число, дробное число
  massReplacement: z
    .object({
      isActive: z.boolean(),
    })
    .nullish(),
});
export type ZAttribute = z.infer<typeof zAttribute>;
